import { useEffect, useState } from 'react'

/**
 * 监听 CSS media query。无 matchMedia 的环境（测试 jsdom、旧浏览器）返回 false，
 * 调用方应按桌面端布局兜底。
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(query).matches,
  )

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return undefined
    }

    const mediaQuery = window.matchMedia(query)
    const syncMatches = (event: MediaQueryListEvent | MediaQueryList) => {
      setMatches(event.matches)
    }

    syncMatches(mediaQuery)
    mediaQuery.addEventListener('change', syncMatches)

    return () => {
      mediaQuery.removeEventListener('change', syncMatches)
    }
  }, [query])

  return matches
}
